import {ActionTree} from "vuex";
import {BalanceFilter, FinanceState, OverdraftFilter} from "@/store/finance/types";
import {RootState} from "@/store/types";
import axios, {AxiosResponse} from "axios";

export const actions: ActionTree<FinanceState, RootState> = {
  getBalances: async ({commit, dispatch}, data: BalanceFilter) => {
    commit('setLoading', true);
    try {
      let resp: AxiosResponse = await axios({url: '/acapi/finance/balances/topups', params: data});
      commit('setBalances', resp.data);
      return resp.data;
    } finally {
      commit('setLoading', false)
    }
  },
  getOverdrafts: async ({commit, dispatch}, data: OverdraftFilter) => {
    commit('setLoading', true);
    try {
      let resp: AxiosResponse = await axios({url: '/acapi/finance/balances', params: data});
      commit('setOverdrafts', resp.data);
      return resp.data;
    } finally {
      commit('setLoading', false)
    }
  },
  putBalance: async ({commit, dispatch}, data: any) => {
    commit('setLoading', true);
    try {
      let resp: AxiosResponse = await axios({
        method: 'put',
        url: `/acapi/finance/balances/${data.id}/balance`,
        data: data.item
      });
      await dispatch('getBalances');
      return resp.data;
    } finally {
      commit('setLoading', false)
    }
  },
  putOverdraft: async ({commit, dispatch}, data: any) => {
    commit('setLoading', true);
    try {
      let resp: AxiosResponse = await axios({
        method: 'put',
        url: `/acapi/finance/balances/${data.id}/overdraft`,
        data: data.item
      });
      console.log(resp.data);
      await dispatch('getOverdrafts');
      return resp.data;
    } finally {
      commit('setLoading', false)
    }
  },
}